import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const pauseBomTemplateBinding = {
  name: "pauseBomTemplateBinding" as const,
  input: z.object({ bindingId: billOfMaterialsTemplateBindingIdFormat.schema }),
  output: z.object({}),
};
